import _get from 'lodash/get'
import { useEffect } from 'react'
import { useNavigate } from 'react-location'

import { FormDialogType } from '../enums/enums'
import { evaluateText } from '../helpers/extensionUtils'
import { searchOrganization, searchProspect } from '../stores/search-store'
import { ExtensionOrganizationData, ExtensionProspectData } from '../types'

type Props = {
  closeDialog: () => void
  openDialog: (
    type: FormDialogType,
    options: { extensionData?: ExtensionProspectData | ExtensionOrganizationData }
  ) => void
}

export default function useGetExtensionMessage(props: Props): void {
  const { openDialog, closeDialog } = props
  const navigate = useNavigate()

  const messageListenerFn = (e: MessageEvent<any>) => {
    const { data: msg } = e
    if (msg?.appText === 'create-new-prospect') {
      window.parent.postMessage({ appAction: 'loading', appText: 'Processing...' }, '*')

      if (msg?.appAction !== 'selected') {
        const { email, fullName } = msg.query
        if (email || fullName) {
          searchProspect({ email, fullName }).then((res) => {
            if (res?.data && res.data.length) {
              window.parent.postMessage({ appAction: 'success', appText: 'Found' }, '*')
              closeDialog()
              navigate({ to: `/prospects/${_get(res, 'data.0.id')}` })
            } else {
              window.parent.postMessage({ appAction: 'success', appText: 'Create' }, '*')
              openDialog(FormDialogType.prospect, { extensionData: msg?.query })
            }
          })
        } else {
          window.parent.postMessage({ appAction: 'hideSnackBar' }, '*')
        }
      } else {
        evaluateText(msg.query).then((data) => {
          if (data.email) {
            searchProspect({ email: data.email }).then((res) => {
              if (res?.data && res.data.length) {
                window.parent.postMessage({ appAction: 'success', appText: 'Found' }, '*')
                closeDialog()
                navigate({ to: `/prospects/${_get(res, 'data.0.id')}` })
              } else {
                window.parent.postMessage({ appText: 'Create' }, '*')
                openDialog(FormDialogType.prospect, { extensionData: data })
              }
            })
          } else {
            window.parent.postMessage({ appAction: 'success', appText: 'Create' }, '*')
            openDialog(FormDialogType.prospect, { extensionData: data })
          }
        })
      }
    } else if (msg?.appText === 'create-new-organization') {
      const name = msg.query.name
      window.parent.postMessage({ appAction: 'loading', appText: 'Processing...' }, '*')

      searchOrganization({ name }).then((res) => {
        if (res?.data && res?.data.length) {
          window.parent.postMessage({ appAction: 'success', appText: 'Found' }, '*')
          closeDialog()
          navigate({ to: `/organizations/${_get(res, 'data.0.id')}` })
        } else {
          window.parent.postMessage({ appAction: 'success', appText: 'Create' }, '*')
          openDialog(FormDialogType.organization, { extensionData: msg.query })
        }
      })
    }
  }

  useEffect(() => {
    window.parent.postMessage({ appAction: 'loggedIn' }, '*')
    try {
      window.addEventListener('message', messageListenerFn)
    } catch (err) {
      console.log('Error Connect')
    }
    return () => {
      window.removeEventListener('message', messageListenerFn)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
